import { RotateCcw, ShieldAlert } from 'lucide-react';

type PlaygroundChatHeaderProps = {
  hasMessages: boolean;
  isResettingOrchestration: boolean;
  onEmergencyRoutingReset: () => void;
  onResetConversation: () => void;
};

export const PlaygroundChatHeader = ({
  hasMessages,
  isResettingOrchestration,
  onEmergencyRoutingReset,
  onResetConversation,
}: PlaygroundChatHeaderProps) => (
  <div className="flex items-center justify-between border-b border-black/10 bg-brand-beige-tint-1 px-6 py-4">
    <div>
      <h3 className="text-lg font-medium text-brand-blue">AI-assistent</h3>
      <p className="text-xs text-text-grey">Chat-first vy för QA av svar, flöden och kontext.</p>
    </div>
    {hasMessages ? (
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={onEmergencyRoutingReset}
          disabled={isResettingOrchestration}
          className="inline-flex items-center gap-2 rounded-sm border border-amber-600 bg-amber-50 px-3 py-2 text-xs uppercase tracking-wider text-amber-800 transition-colors duration-200 hover:bg-amber-600 hover:text-white disabled:cursor-not-allowed disabled:opacity-60"
        >
          <ShieldAlert className="h-4 w-4" />
          {isResettingOrchestration ? 'Återställer...' : 'Nödstopp routing'}
        </button>
        <button
          type="button"
          onClick={onResetConversation}
          className="inline-flex items-center gap-2 rounded-sm border border-brand-blue bg-white px-3 py-2 text-xs uppercase tracking-wider text-brand-blue transition-colors duration-200 hover:bg-brand-blue hover:text-white"
        >
          <RotateCcw className="h-4 w-4" />
          Nollställ
        </button>
      </div>
    ) : null}
  </div>
);
